// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bWQYX","content":"styles_content__Q4gBN"};